import React from 'react';
import Button from '../Globle/Button';
import { CiSquarePlus } from 'react-icons/ci';
import { Searchbar } from './Searchbar';
import { ProjectList } from './ProjectList';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';

export const HomePage = observer(() => {
    const { viewManager } = useMainContext();
    return (
        <div className="px-[24px] py-[18px]">
            <div className="flex justify-between items-center">
                <h1 className=" font-druk text-[56px] font-medium leading-[46px] text-theme-black ">
                    Projects
                </h1>
                <Button
                    label="Create New Project"
                    icon={CiSquarePlus}
                    onClick={() => viewManager.setOpenForm(true)}
                />
            </div>
            <ProjectList />
        </div>
    );
});
